/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-default-export */
import { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import { ProductPreviewCard } from 'components/card'
import { InfoButton } from 'components/buttons'
import { track, tracking, TrackVisibility } from 'lib/analytics'

// @FIXME: borrow styles from feed-items for now
import css from 'registry/home/components/feed-items/feed-items.scss'
import { SubHeading } from '../../components/headings'

export const ProductCollection = ({
  QuickAddRegItemProps,
  id,
  maxVisibleProducts,
  products,
  showQuickAddRegItem,
  teaser,
  title,
}) => {
  // passed down to ProductPreview
  const avoTrackingProperties = {
    productCollectionId: id,
    productCollectionTitle: title,
    productIds: map(products, (p) => p.id),
  }

  return (
    <TrackVisibility
      eventProperties={{
        event: track.productCollectionViewed,
        ...avoTrackingProperties,
      }}
    >
      <div className={classNames(css.ecommerceLayout, 'mbxl')}>
        <SubHeading className="text-bold mll" style={{ marginTop: 0 }}>
          {title}
        </SubHeading>
        <p className="pbm mll">{teaser}</p>

        <ToggleState>
          {({ isToggleOn: showAllProducts, onToggle }) => {
            const productsToDisplay =
              showAllProducts || maxVisibleProducts === null
                ? products
                : products.slice(0, maxVisibleProducts)
            return (
              <>
                <ProductsLayout>
                  {productsToDisplay.map((product) => (
                    <ProductPreview
                      key={product.id}
                      avoTrackingProperties={avoTrackingProperties}
                      product={product}
                      QuickAddButtonComponent={
                        showQuickAddRegItem && (
                          <ProductPreviewCard.QuickAddRegItem
                            product={product}
                            {...QuickAddRegItemProps}
                          />
                        )
                      }
                    />
                  ))}
                </ProductsLayout>

                {products.length > maxVisibleProducts &&
                  maxVisibleProducts !== null && (
                    <div className="text-center">
                      <InfoButton
                        onClick={onToggle}
                        className="text-center mtl"
                        pill
                        empty
                        size="small"
                      >
                        {!showAllProducts
                          ? `+ ${products.length - maxVisibleProducts} More`
                          : `View Less`}
                      </InfoButton>
                    </div>
                  )}
              </>
            )
          }}
        </ToggleState>
      </div>
    </TrackVisibility>
  )
}

ProductCollection.defaultProps = {
  QuickAddRegItemProps: {},
  maxVisibleProducts: 4,
  showQuickAddRegItem: false,
}

ProductCollection.propTypes = {
  QuickAddRegItemProps: PropTypes.shape({ source: PropTypes.string }),
  id: PropTypes.string.isRequired,
  maxVisibleProducts: PropTypes.number,
  products: PropTypes.array.isRequired,
  showQuickAddRegItem: PropTypes.bool,
  teaser: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

const ProductsLayout = ({ children }) => (
  <div className={css.sliderLayout}>{children}</div>
)

class ToggleState extends Component {
  state = {
    isToggleOn: false,
  }

  toggle = () => {
    this.setState({ isToggleOn: !this.state.isToggleOn })
  }

  render() {
    return this.props.children({
      isToggleOn: this.state.isToggleOn,
      onToggle: this.toggle,
    })
  }
}

const ProductPreview = ({
  avoTrackingProperties,
  product,
  QuickAddButtonComponent,
}) => {
  const ProductPreviewCardWithTracking = tracking({
    ...avoTrackingProperties,
    productIds: [product.id],
    product,
    events: [track.productCollectionClicked, track.productClicked],
  })(ProductPreviewCard)

  return (
    <ProductPreviewCardWithTracking
      {...product}
      size="medium"
      QuickAddButtonComponent={QuickAddButtonComponent}
    />
  )
}
